import React from 'react';
import { useTranslation } from 'react-i18next';

export default function I18nProof({ bundle }) {
  const { t } = useTranslation('common');
  return <p className="i18n-proof-message">{t('proof.react', { bundle })}</p>;
}
